import React, {useEffect, useRef} from "react";
import {message} from "antd";
import {useNavigate} from "react-router-dom";
import {useSetState} from "ahooks";
import {SActionBtn, SCommonTable, SIDRender, SMessage, STableActions} from "shj-components";
import AllowcateWorkerModal from "@/components/AllowcateWorkerModal";
import {cancelOrder} from "@/services/order.ts";
import {getBizTypeTag, getOrderStatusTag} from "@/pages/salesWorkbench/workbenchList/until.tsx";
import {getColumns} from "./config.tsx";
import {getBizOrder} from "@/services/saleOpServices.ts";
import { quickPlaceOrder } from '@/services/order.ts';
import dayjs from 'dayjs';
import {openInNewTab} from "@/utils/queryParse.ts";

type IProps = {
  clueId: number;
  listRef: any;
  open: boolean;
  searchChange: boolean;
  searchQuery: Record<string, any>;
}

const ExpandTableList = (props: IProps) => {
  const {clueId, listRef, searchChange, open, searchQuery = {}} = props;
  const tableRef = useRef<any>();
  const navigate = useNavigate()
  const [state, setState] = useSetState({
    open: false,
    record: {},
    changeDispatcherOpen: false, //改派
    batchEditId: [],
  })

  useEffect(() => {
    if (open) {
      tableRef?.current?.reload?.();
    }
  }, [open, searchChange]);

  const fetchList = () => {
    if (!open) return;
    return new Promise((resolve, reject) => {
      getBizOrder({data: {...searchQuery, clueId}}).then(res => {
        console.log(res, 'data')
        resolve({data: { data: res || [] }, success: true})
      }).catch(reject)
    })

  }

  const onChangeEmp = (batchEditId) => {
    setState({batchEditId, changeDispatcherOpen: true})
  }

  const onCancelOrder = id => {
    SMessage.confirm({
      title: '确认取消订单？',
      content: null,
      onOk: async () => {
        try {
          await cancelOrder({params: {orderId: id}})
          message.success('操作成功')
          listRef.current?.reload()
           return Promise.resolve(true)
        } catch (err) {
          return Promise.resolve(true)
        }
      },
    });
  }

  const createOrder = (trackId: string) => {
    SMessage.confirm({
      title: '提示',
      content: '确认后系统会快速生成订单，请告知财务订单号和客户名称以便收款，收款后再完善产品报价',
      onOk: async () => {
        try {
          const res = await quickPlaceOrder({ trackId })
          if (res && typeof res === 'string') {
            message.success('创建订单成功')
            listRef.current?.reload()
            setTimeout(() => {
              window.open(`/order/list/details/${res}`)
            }, 800)
          }
          return true
        } catch (err) {
          return Promise.resolve(true)
        }
      },
    });
  }

  const clickToOrder = (record: any) => {
    window.open(`/deal/basetd/understand/online-shop?onlyBuy=true&trackPlanId=${record.trackPlanId || ''}`)
  }

  const actionsFn = {
    IdRender(text: any) {
      return (
          <SIDRender
              id={text}
              onClick={() => {
                openInNewTab(`/saleOp/salesWorkBench/salesWorkBenchDetail/${clueId}?templateNodeId=${text}`)
              }}
          />
      )
    },
    orderIdRender(text: any, record: any) {

      return (
          <SIDRender
              id={text}
              onClick={() => {
                openInNewTab(record.bizType === 'productTypeRetail' ? `/order/list/details/direct-index/${record.orderId}` : `/order/list/details/${record.orderId}`)
              }}
          />
      )
    },
    orderStatusRender(text: any) {
      return getOrderStatusTag(text)
    },
    bizTypeRender(text: any) {
      return getBizTypeTag(text)
    },
    actionRender(_, record) {
      return (
        <STableActions>
          <SActionBtn
            auth={'salesWorkBenchReassignmentDesigner'}
            onClick={() => onChangeEmp([record.trackPlanId])}
          >
            改派设计师
          </SActionBtn>
        {/*  {(record.orderStatus === 'waitPay' || record.orderStatus === 'waitSign') && (
            <SActionBtn onClick={() => onCancelOrder(record.orderId)}>取消订单</SActionBtn>
          )}*/}
          {(!record.orderStatus || record.orderStatus === 'expired') ? (
            <SActionBtn onClick={() => clickToOrder(record)}>去下单</SActionBtn>
          ) : null}
          {
            !record.orderCode ? (
              <SActionBtn onClick={() => createOrder(record?.trackPlanId)}>去收款</SActionBtn>
            ) : null
          }
        </STableActions>
      )
    },
    timeRender(_, record: any) {
      return record?.signTime
        ? dayjs(record?.signTime).format('YYYY/MM/DD')
        : ''
    }
  }

  return (
      <>
        <SCommonTable columns={getColumns(actionsFn)} scroll={{y: 350}} ref={tableRef} request={fetchList} toolbar={false}
                      pagination={false}/>

        {/** 分配服务人员弹窗 */}
        {state.changeDispatcherOpen &&
            <AllowcateWorkerModal isEditTitle={'改派'} isListOperation={true}
                                  buttonKey={'ASSIGN_DESIGNER'}
                                  reload={listRef.current?.reload}
                                  isBatch={true}
                                  trackPlanId={state.batchEditId} open={state.changeDispatcherOpen}
                                  onClose={() => setState({changeDispatcherOpen: false})}/>}
      </>
  )
}

export default ExpandTableList